import { Avatar, Box, Button, Flex, Image, Stack, Text } from "@mantine/core";
import { IconHistory, IconStarFilled } from "@tabler/icons-react";

export default function _CourseList2({ component }) {

	return (
		<Stack
			component="section"
			mx={component?.customize_styles?.general_decoration?.margin_x}
			my={component?.customize_styles?.general_decoration?.margin_y}
			bd={`${component?.customize_styles?.general_decoration?.border_width} solid ${component?.customize_styles?.general_decoration?.border_color}`}
			bg={component?.customize_styles?.general_decoration?.background_color}
			px={component?.customize_styles?.general_decoration?.padding_x}
			py={component?.customize_styles?.general_decoration?.padding_y}
			style={{
				borderRadius: parseInt(component?.customize_styles?.general_decoration?.border_radius),
				boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
			}}
		>
			{/* ---------- course list ---------- */}
			<Stack>
				{component?.items?.map((course) => (
					<Stack
						gap={10}
						key={course?.id}
						align="center"
						bg={component?.customize_styles?.box_decoration?.background_color}
						mx={component?.customize_styles?.box_decoration?.margin_x}
						my={component?.customize_styles?.box_decoration?.margin_y}
						px={component?.customize_styles?.box_decoration?.padding_x}
						py={component?.customize_styles?.box_decoration?.padding_y}
						bd={`${component?.customize_styles?.box_decoration?.border_width} solid ${component?.customize_styles?.box_decoration?.border_color}`}
						style={{
							borderRadius:
								component?.customize_styles?.box_decoration?.border_radius,
						}}
					>
						<Box
							pos="relative"
							lh={0}
							ta={component?.customize_styles?.image_decoration?.alignment}
						>
							<Image
								display="inline-block"
								src={course?.thumbnail}
								h={component?.customize_styles?.image_decoration?.height}
								w={component?.customize_styles?.image_decoration?.width ?? "100%"}
								fit={component?.customize_styles?.image_decoration?.boxfit}
								radius={component?.customize_styles?.image_decoration?.radius}
							/>
							{/* --------- course duration --------- */}
							<Flex
								align="center"
								gap={3}
								bg="#E7924D"
								px={14}
								py={6}
								pos="absolute"
								top={10}
								right={10}
								style={{ borderRadius: "16px" }}
							>
								<IconHistory color="#fff" size={18} />
								<Text lh={0} fw={600} c="#fff" size="14px">
									{course?.total_duration?.hours}h{" "}
									{course?.total_duration?.minutes}m{" "}
									{course?.total_duration?.seconds}s
								</Text>
							</Flex>
						</Box>
						<Box w={"100%"}>
							<Flex mb={10} gap={3} align="center" wrap="wrap">
								{course?.categories?.map((category) => (
									<Button
										key={category}
										variant="outline"
										h={28}
										fz={
											component?.customize_styles?.category_text_decoration
												?.font_size
										}
										c={
											component?.customize_styles?.category_text_decoration
												?.color
										}
										bg={"#F0F2F5"}
										bd={`1px solid #E1E4EA`}
										radius={50}
										fs={
											component?.customize_styles?.category_text_decoration
												?.font_style
										}
										fw={
											component?.customize_styles?.category_text_decoration
												?.font_weight
										}
										ff={
											component?.customize_styles?.category_text_decoration
												?.font_family
										}
										ta={
											component?.customize_styles?.category_text_decoration
												?.text_align
										}
										lh={
											component?.customize_styles?.category_text_decoration
												?.text_height
										}
										lts={
											component?.customize_styles?.category_text_decoration
												?.letter_spacing
										}
										style={{
											textDecorationLine:
												component?.customize_styles
													?.category_text_decoration?.text_decoration,
											textDecorationColor:
												component?.customize_styles
													?.category_text_decoration?.decoration_color,
											textDecorationThickness:
												component?.customize_styles
													?.category_text_decoration
													?.decoration_thickness,
										}}
									>
										{category}
									</Button>
								))}
							</Flex>
							<Text
								c={component?.customize_styles?.name_text_decoration?.color}
								ff={component?.customize_styles?.name_text_decoration?.font_family}
								fz={component?.customize_styles?.name_text_decoration?.font_size}
								fw={component?.customize_styles?.name_text_decoration?.font_weight}
								lh={component?.customize_styles?.name_text_decoration?.text_height}
								lts={
									component?.customize_styles?.name_text_decoration
										?.letter_spacing
								}
								lineClamp={2}
								style={{
									textOverflow:
										component?.customize_styles?.name_text_decoration
											?.text_overflow,
								}}
							>
								{course?.name}
							</Text>
							<Flex gap={8} align="center">
								{/* ------- course review ------- */}
								<Flex my={14} align="center" gap={5}>
									<IconStarFilled color="#FEA055" size={17} />
									<Flex align="center" gap={3}>
										<Text
											c={
												component?.customize_styles?.rating_text_decoration
													?.color
											}
											fz={
												component?.customize_styles?.rating_text_decoration
													?.font_size
											}
											fw={
												component?.customize_styles?.rating_text_decoration
													?.font_weight
											}
											fs={
												component?.customize_styles?.rating_text_decoration
													?.font_style
											}
											ff={
												component?.customize_styles?.rating_text_decoration
													?.font_family
											}
											lh={
												component?.customize_styles?.rating_text_decoration
													?.text_height
											}
											lts={
												component?.customize_styles?.rating_text_decoration
													?.letter_spacing
											}
											style={{
												textOverflow:
													component?.customize_styles
														?.rating_text_decoration?.text_overflow,
											}}
										>
											{course?.rating}
										</Text>
										<Text c="#5E6066" size="12px">
											({course?.rating_count} reviews)
										</Text>
									</Flex>
								</Flex>
								<Box
									mt={1}
									w={4}
									h={4}
									bg="#5E6066"
									style={{ borderRadius: "50%" }}
								/>
								{/* ------- course registration information --------- */}
								<Flex align="center" gap={4}>
									<Text c="#5E6066" size="14px">
										{course?.total_students} Students
									</Text>
								</Flex>
							</Flex>
							{/* ----------- course author ---------- */}
							<Flex align="center" gap={5}>
								<Avatar
									c={component?.customize_styles?.avatar_decoration?.color}
									h={component?.customize_styles?.avatar_decoration?.height}
									w={component?.customize_styles?.avatar_decoration?.width}
									src={course?.author?.avatar}
									radius={component?.customize_styles?.avatar_decoration?.radius}
								/>
								<Flex gap={4} align="center">
									<Text c="#5E6066" size="14px">
										By
									</Text>
									<Text
										ff={
											component?.customize_styles?.author_text_decoration
												?.font_family
										}
										fw={
											component?.customize_styles?.author_text_decoration
												?.font_weight
										}
										fz={
											component?.customize_styles?.author_text_decoration
												?.font_size
										}
										c={
											component?.customize_styles?.author_text_decoration
												?.color
										}
										lh={
											component?.customize_styles?.author_text_decoration
												?.text_height
										}
										lts={
											component?.customize_styles?.author_text_decoration
												?.letter_spacing
										}
										style={{
											textOverflow:
												component?.customize_styles?.author_text_decoration
													?.text_overflow,
										}}
									>
										{course?.author?.name}
									</Text>
								</Flex>
							</Flex>
							{/* -------- course price information --------- */}
							<Flex gap={7} align="center" mt={10} mb={20}>
								<Text
									fs={
										component?.customize_styles?.sales_price_text_decoration
											?.font_style
									}
									fz={
										component?.customize_styles?.sales_price_text_decoration
											?.font_size
									}
									ff={
										component?.customize_styles?.sales_price_text_decoration
											?.font_family
									}
									fw={
										component?.customize_styles?.sales_price_text_decoration
											?.font_weight
									}
									c={
										component?.customize_styles?.sales_price_text_decoration
											?.color
									}
									lh={
										component?.customize_styles?.sales_price_text_decoration
											?.text_height
									}
									lts={
										component?.customize_styles?.sales_price_text_decoration
											?.letter_spacing
									}
									style={{
										textOverflow:
											component?.customize_styles?.sales_price_text_decoration
												?.text_overflow,
										textDecorationLine:
											component?.customize_styles?.sales_price_text_decoration
												?.text_decoration,
										textDecorationColor:
											component?.customize_styles?.sales_price_text_decoration
												?.decoration_color,
										textDecorationThickness:
											component?.customize_styles?.sales_price_text_decoration
												?.decoration_thickness,
									}}
								>
									${course?.course_price?.sale_price}
								</Text>
								<Text
									ta={
										component?.customize_styles?.regular_price_text_decoration
											?.text_align
									}
									ff={
										component?.customize_styles?.regular_price_text_decoration
											?.font_family
									}
									fs={
										component?.customize_styles?.regular_price_text_decoration
											?.font_style
									}
									fz={
										component?.customize_styles?.regular_price_text_decoration
											?.font_size
									}
									fw={
										component?.customize_styles?.regular_price_text_decoration
											?.font_weight
									}
									c={
										component?.customize_styles?.regular_price_text_decoration
											?.color
									}
									lh={
										component?.customize_styles?.regular_price_text_decoration
											?.text_height
									}
									lts={
										component?.customize_styles?.regular_price_text_decoration
											?.letter_spacing
									}
									style={{
										textDecorationLine:
											component?.customize_styles
												?.regular_price_text_decoration?.text_decoration,
										textDecorationColor:
											component?.customize_styles
												?.regular_price_text_decoration?.decoration_color,
										textDecorationThickness:
											component?.customize_styles
												?.regular_price_text_decoration
												?.decoration_thickness,
									}}
								>
									${course?.course_price?.regular_price}
								</Text>
							</Flex>
							{/* <============ box button ============> */}
							<Box
								mx={component?.customize_styles?.button_decoration?.margin_x}
								my={component?.customize_styles?.button_decoration?.margin_y}
							>
								<Button
									px={component?.customize_styles?.button_decoration?.padding_x}
									py={component?.customize_styles?.button_decoration?.padding_y}
									c={"#3C4AB4"}
									radius={
										component?.customize_styles?.button_decoration
											?.border_radius
									}
									w="100%"
									h="40px"
									fw={500}
									fz="14px"
									bg={
										component?.customize_styles?.button_decoration
											?.background_color
									}
									bd={`${component?.customize_styles?.button_decoration?.border_width} solid ${component?.customize_styles?.button_decoration?.border_color}`}
								>
									<Text
										fz={
											component?.customize_styles?.button_text_decoration
												?.font_size
										}
										ff={
											component?.customize_styles?.button_text_decoration
												?.font_family
										}
										fw={
											component?.customize_styles?.button_text_decoration
												?.font_weight
										}
										c={
											component?.customize_styles?.button_text_decoration
												?.color
										}
										lts={
											component?.customize_styles?.button_text_decoration
												?.letter_spacing
										}
										lh={
											component?.customize_styles?.button_text_decoration
												?.text_height
										}
										display="flex"
									>
										{course?.button_text}
									</Text>
								</Button>
							</Box>
						</Box>
					</Stack>
				))}
			</Stack>
		</Stack>
	);
}
